import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as StatusBarSolution } from '../../../assets/svg/StatusBarSolution.svg';
import { createEditExtraSuggestion, getSolutionById } from '../../../server/server';
import TopicScreen from './TopicScreen';
import SolutionScreen from './SolutionScreen';
import AudioSolution from './AudioSolution';
import ExtraSuggestionScreen from './ExtraSuggestionScreen';

function TopicPreviewModal({ modalIsOpen, closeModal, currentTopic }: { modalIsOpen: any; closeModal: any; currentTopic: any }) {
	const [currentMode, setCurrentMode] = useState('topic');
	const [solution, setSolution] = useState<any>(null);
	const [time, setTime] = useState('');
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const intervalId = setInterval(() => {
			const currentTime = new Date();
			const hours = currentTime.getHours().toString().padStart(2, '0');
			const minutes = currentTime.getMinutes().toString().padStart(2, '0');
			const formattedTime = `${hours}:${minutes}`;
			setTime(formattedTime);
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	const resetModal = () => {
		setCurrentMode('topic');
	};

	const loadSolution = async (id: string) => {
		setLoading(true);
		const resp = await getSolutionById(id);
		if (resp.status == 200) {
			setCurrentMode('solution');
			setSolution(resp.data);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};
	const openSolution = (id: string) => {
		loadSolution(id);
	};
	return (
		<ReactModal
			ariaHideApp={false}
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => resetModal()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 0,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 900,
					margin: 'auto',
					backgroundColor: 'transparent',
					height: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='w-[375px] max-h-[812px] h-[calc(100vh-90px)] rounded-[10px] m-auto bg-[#CAE5FF] relative mt-[30px] '>
				<div
					className='w-[50px] h-[50px] bg-primaryViolet rounded-full cursor-pointer flex items-center justify-center z-[2] absolute -top-[25px] left-[calc(50%-25px)] hover:bg-darkenPurple'
					onClick={() => closeModal()}
				>
					<CloseModalIcon />
				</div>
				<div className='h-full overflow-hidden relative rounded-[10px]'>
					<div className='relative'>
						<StatusBarSolution />
						<div className='absolute top-[13px] left-[24px] text-[15px] leading-5 font-semibold text-darkenPurple'>{time}</div>
					</div>
					{currentMode === 'topic' && <TopicScreen currentTopic={currentTopic} openSolution={openSolution} setCurrentMode={setCurrentMode} />}
					{currentMode === 'solution' && <SolutionScreen solution={solution} currentTopic={currentTopic} setCurrentMode={setCurrentMode} openSolution={(id: any) => loadSolution(id)} />}
					{currentMode === 'suggestion' && <ExtraSuggestionScreen setCurrentMode={setCurrentMode} currentTopic={currentTopic} />}
				</div>
			</div>
		</ReactModal>
	);
}

export default TopicPreviewModal;
